
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { MolhamLanguagesObject } from "apiTypes";
import ProfileMenuItem from "components/Profile/ProfileMenuItem";
import AboutLayout from "layout/AboutLayout";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { getStaticPagesLayoutData } from "ssrUtils";
export type AboutLayoutProps = {
    pages: {
        slug: string;
        title: MolhamLanguagesObject;
        description: MolhamLanguagesObject;
    }[];
};
const About: React.FC<AboutLayoutProps> = ({ pages }) => {
    const paths = [
        { path: "/about/about", name: "about" },
        { path: "/about/molham", name: "molham" },
        { path: "/about/mission", name: "mission" },
        { path: "/about/programs", name: "programs" },
        { path: "/about/legalnotice", name: "legalnotice" },
        { path: "/about/reports", name: "annual-reports" },
    ];
    const content = paths.map((path) => {
        return {
            content: pages?.find((page) => page.slug === path.name) || {
                title: path.name,
                description: path.name,
                body: path.name
            },
            path
        };
    });
    const { locale } = useRouter();
    const { t } = useTranslation("common");
    const isObject = (obj: Object): obj is object => {
        return obj !== null && typeof obj === "object";
    };
    return (<>
      {/* SEO in layout */}
      <div className="d-flex flex-column align-items-center justify-content-center list-group list-group-flush h-100">
        {content.map((item, i) => {
            return (<ProfileMenuItem key={i} title={isObject(item?.content?.title)
                    ? item?.content?.title[locale]
                    : t(item.content.title)} desc={isObject(item?.content?.description)
                    ? item?.content?.description[locale]
                    : t(item.content.description)} icon={"fe-book"} href={item.path.path}/>);
        })}
      </div>
    </>);
};
export default About;
(About as any).Layout = AboutLayout;
const getStaticProps = getStaticPagesLayoutData;

    async function __Next_Translate__getStaticProps__1a13f66bed7__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bed7__ as getStaticProps }
  